import { polyfill } from '@lemon8/web-scaffold/polyfill';
import {
  setupJotai,
  setupFetch,
  startHydrating,
  collectPreRenderedStyles,
  initHeadManager,
} from '@lemon8/web-app-shared/ssr';

import 'core-js/es/array/at';

setupJotai();
setupFetch();
collectPreRenderedStyles();

console.log('variant: %s', __BUILD_VARIANT__);

if (__BUILD_VARIANT__ === 'hydrate_root') {
  initHeadManager();
}

void polyfill().then(() => {
  startHydrating(__BUILD_VARIANT__ === 'hydrate_root' ? 'root' : 'html');
});
